// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--mq3_0","list":"_02712f2b3b--list--ZH_p3","item":"_02712f2b3b--item--lA4F3","link":"_02712f2b3b--link--XJdUk"};